import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";
import { Localvalue } from "../../nametitle/localValue";


// Créer un compte 
export const CreateMessage = (name, email,subject, telephone, content,toast) => {
  var data = JSON.stringify({
    "name": name,
    "subject": subject,
    "email": email,
    "telephone": telephone,
    "content": content
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/messages/`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      alert("votre message a été envoyé et sera traiter");
      toast.success("Message envoyé");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    })
    .catch(function (error) {
      toast.success("Message envoyé");
    });
}

// Mise ajour du compte 
export const UpdateMessage = (id, name, coverPicture, email, code, telephone) => {
  var data = JSON.stringify({
    "name": name,
    "coverPicture": coverPicture,
    "email": email,
    "code": code,
    "telephone": telephone,
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/messages/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };

  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
    })
    .catch(function (error) {
      //console.log(error);
    });

}





// ************************************************************** Mise à jour du mot de passe




// ************************************************ Bloquer acces au compte
export const StopMessage = (id) => {
  var data = JSON.stringify({
    "access": Boolean(false),
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/messages/hide/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload()
    })
    .catch(function (error) {
      //console.log(error);
    });
}




// ********************************************* Débloquer un compte
export const AccessMessage = (id) => {
  var data = JSON.stringify({
    "access": Boolean(true),
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/messages/show/${id}`,
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}


// Recupérer tout compte des membres
export const LoadAllMessage = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/messages/get/all`, {
    headers: {
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0',
      'Authorization': `Bearer ${baseUrl.token}`
    }})
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data);
    })
    .catch(function (error) {
      //console.log(error);
    });
}
